const state = () => ({
    steps: [
        { id: 1, label: 'Your business', component: 'InformationStep', isActive: false },
        { id: 2, label: 'Consumption', component: 'WaterConsumptionStep', isActive: false },
        { id: 3, label: 'Choose a quote', component: 'QuoteStep', isActive: false }, 
        { id: 4, label: 'Payment details', component: 'PaymentStep', isActive: false }, 
        { id: 5, label: 'Confirmation', component: 'CompleteStep', isActive: false },
    ]
}) 

const getters = { 
    /**
    * Retrieves current active component name
    */
    currentStepComponent: state => {
        const activeStep = state.steps.filter(step => step.isActive);

        if (activeStep.length == 0) {
            return 'IntroStep';
        }

       return activeStep[0].component; 
    },

    /**
     * Retrieves current active step id
     */
    currentStepId: state => {
        const [activeStep] = state.steps.filter(step => step.isActive);

        if (activeStep == undefined) {
            return null;
        }

        return activeStep.id;
    },
}

const actions = {
    /** 
    * Toggles trainee step Vuex mutation
    */
    toggleTraineeStep({ commit }) {
        commit('toggleTraineeStep');
    },

    startQuoteTool({ commit }) {
        commit('toggleFirstStep');
    },

    toggleDropoutConfirmationStep({ commit }) {
        commit('updateDropoutConfirmationStep')
    },

    toggleConfirmationStep({ commit }) {
        commit('updateConfirmationStep')
    },
}

const mutations = {
    /**
    * Toggles next active step 
    * @param {any} state - Vuex module state
    * @param {number} stepId - ID of the step which needs to be toggled
    */
    toggleStep(state) {
        const [activeStep] = state.steps.filter(step => step.isActive);

        activeStep.isActive = false;

        const nextActiveStepId = activeStep.id + 1;

        const [nextActiveStep] = state.steps.filter(step => step.id === nextActiveStepId);

        nextActiveStep.isActive = true;
    },

    toggleFirstStep(state) {
        state.steps[0].isActive = true;
    },

    updateDropoutConfirmationStep(state) {
        const [activeStep] = state.steps.filter(step => step.isActive);

        activeStep.isActive = false;
        activeStep.component = 'DropoutCompleteStep';  
        activeStep.isActive = true;
    },

    updateConfirmationStep(state) { 
        const [confirmationStep] = state.steps.filter(step => step.id == 5)

        confirmationStep.isActive = true;
    },

    updateStepTitleLabels(state, stepLabels) {
        for (let stepIndex = 0; stepIndex < stepLabels.length; stepIndex++) {
            const [step] = state.steps.filter(step => step.id == stepLabels[stepIndex].id);
            step.label = stepLabels[stepIndex].label;
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
